// adding - and + buttons to the quantity box of cart drawer line-item
(function () {
  function sync(stepper) {
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-action="minus"]');
    var plus = stepper.querySelector('[data-action="plus"]');
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10);
    var step = parseInt(input.step, 10) || 1;
    var val = parseInt(input.value, 10) || min;

    minus.disabled = val - step < min;
    plus.disabled = !isNaN(max) && val + step > max;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-drawer .qty-stepper__btn');
    if (!btn || btn.disabled) return;

    var stepper = btn.closest('.cart-drawer .qty-stepper');
    var input = stepper.querySelector('input');

    // stepUp/stepDown respect min, max and step (the variant's quantity rules)
    if (btn.dataset.action === 'plus') input.stepUp();
    else input.stepDown();

    sync(stepper);
    // Same event the theme listens to when someone types a number, so its cart update runs untouched
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Keep buttons in sync if the quantity is typed manually
  document.addEventListener('change', function (e) {
    var stepper = e.target.closest && e.target.closest('.cart-drawer .qty-stepper');
    if (stepper) sync(stepper);
  });
})();

// confirmation pop-up before removing line-item from the cart-drawer
(function () {
  var bypass = false;
  var popup = null;
  var lastLink = null;

  // Outermost full-height ancestor inside the drawer = the drawer panel
  function findPanel(el) {
    var drawer = el.closest('cart-drawer');
    var panel = null;
    var node = el.parentElement;
    while (node && node !== drawer && node !== document.body) {
      if (node.getBoundingClientRect().height >= window.innerHeight * 0.9) panel = node;
      node = node.parentElement;
    }
    return panel || drawer || document.body;
  }

  function close() {
    if (!popup) return;
    popup.remove();
    popup = null;
    document.removeEventListener('keydown', onKey, true);
    if (lastLink && document.contains(lastLink)) lastLink.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      e.stopPropagation(); // don't let the drawer close underneath
      close();
    }
  }

  function open(link) {
    var line = link.closest('line-item');
    if (!line) return false;

    var img = line.querySelector('.line-item__media');
    var nameEl = line.querySelector('.line-item__info .bold');
    var priceEl = line.querySelector('price-list');
    var qtyEl = line.querySelector('input.quantity-input');

    var panel = findPanel(line);
    if (getComputedStyle(panel).position === 'static') panel.style.position = 'relative';

    popup = document.createElement('div');
    popup.className = 'rm-confirm';
    popup.setAttribute('role', 'alertdialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-label', 'Remove item confirmation');

    popup.innerHTML =
      '<div class="rm-confirm__sheet">' +
        '<div class="rm-confirm__head">' +
          '<span>Remove 1 item from your cart?</span>' +
          '<button type="button" class="rm-confirm__close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="rm-confirm__body">' +
          (img ? '<img class="rm-confirm__img" alt="">' : '') +
          '<div class="rm-confirm__info">' +
            '<div class="rm-confirm__name"></div>' +
            (qtyEl ? '<div class="rm-confirm__qty"></div>' : '') +
          '</div>' +
          '<div class="rm-confirm__price"></div>' +
        '</div>' +
        '<button type="button" class="rm-confirm__yes">Yes, remove</button>' +
      '</div>';

    // Fill with textContent / cloned markup so nothing is injected as raw strings
    if (img) popup.querySelector('.rm-confirm__img').src = img.currentSrc || img.src;
    popup.querySelector('.rm-confirm__name').textContent = nameEl ? nameEl.textContent.trim() : '';
    if (qtyEl) popup.querySelector('.rm-confirm__qty').textContent = 'Qty: ' + qtyEl.value;
    if (priceEl) popup.querySelector('.rm-confirm__price').innerHTML = priceEl.innerHTML;

    popup.addEventListener('click', function (e) {
      if (e.target === popup || e.target.closest('.rm-confirm__close')) close();
    });

    popup.querySelector('.rm-confirm__yes').addEventListener('click', function () {
      var link = lastLink;
      close();
      if (!link || !document.contains(link)) return;
      bypass = true;
      link.click(); // the theme's own remove handling runs from here
      bypass = false;
    });

    panel.appendChild(popup);
    document.addEventListener('keydown', onKey, true);
    popup.querySelector('.rm-confirm__yes').focus();
    return true;
  }

  // Capture phase: runs before the theme's click handler on the link
  document.addEventListener('click', function (e) {
    if (bypass) return;
    var link = e.target.closest('cart-drawer line-item-quantity a');
    if (!link) return;

    e.preventDefault();
    e.stopPropagation();
    lastLink = link;
    if (!open(link)) {
      bypass = true;
      link.click();
      bypass = false;
    }
  }, true);
})();

// document.addEventListener('DOMContentLoaded', function () { //auto-switching tabs in center for all tabbed sections
//   const allXTabs = document.querySelectorAll('x-tabs');

//   allXTabs.forEach(xTabs => {
//     if (!xTabs.shadowRoot) return;

//     const shadow = xTabs.shadowRoot;
//     const tabButtons = shadow.querySelector('slot[name="title"]')?.assignedElements() || [];

//     const tablistContainer = shadow.querySelector('.top-container-tpd');
//     if (!tablistContainer) return;

//     tabButtons.forEach(button => {
//       button.addEventListener('click', function () {
//         const containerRect = tablistContainer.getBoundingClientRect();
//         const buttonRect = button.getBoundingClientRect();

//         if (buttonRect.left < containerRect.left || buttonRect.right > containerRect.right) {
//           const scrollAmount = button.offsetLeft - tablistContainer.offsetWidth / 2 + button.offsetWidth / 2;
//           tablistContainer.scrollTo({ left: scrollAmount, behavior: 'smooth' });
//         }
//       });
//     });
//   });
// });

// (function () { // close accordion when current one is opened

//     // Exit if collection section exists
//     //   if (document.querySelector('.shopify-section--main-collection')) {
//     //     return;
//     //   }

//   const SEL = 'details[is="accordion-disclosure"], accordion-disclosure';

//   function isAccordion(el) {
//     return !!el && (el.matches?.(SEL));
//   }

//   // Find the group container so we only close siblings in the same block/section.
//   function getGroupRoot(acc) {
//     // Prefer a nearby ancestor that actually contains multiple accordions.
//     let node = acc.parentElement;
//     for (let i = 0; i < 6 && node; i++) {
//       const count = node.querySelectorAll(SEL).length;
//       if (count > 1) return node;
//       node = node.parentElement;
//     }
//     return acc.parentElement || document; // safe fallback
//   }

//   function closeSiblingsOf(acc) {
//     const root = getGroupRoot(acc);
//     const list = root.querySelectorAll(SEL);
//     list.forEach((other) => {
//       if (other !== acc && other.open) {
//         // Use the component's own API so Impact's animation runs
//         other.open = false;
//       }
//     });
//   }

//   // 1) Capture click on <summary> before Impact toggles 'open'
//   document.addEventListener('click', function (e) {
//     const summary = e.target.closest('summary');
//     if (!summary) return;

//     const acc = summary.closest(SEL);
//     if (!isAccordion(acc)) return;

//     // If it's currently closed, it's about to open -> close others first
//     // (We are in capture phase, before the theme flips open state)
//     if (!acc.open) {
//       closeSiblingsOf(acc);
//     }
//   }, true); // <- capture

//   // 2) Also watch for programmatic opens (Theme Editor, JS) and enforce one-open rule
//   const mo = new MutationObserver((mutations) => {
//     for (const m of mutations) {
//       if (m.type === 'attributes' && m.attributeName === 'open') {
//         const acc = m.target;
//         if (isAccordion(acc) && acc.open) {
//           closeSiblingsOf(acc);
//         }
//       }
//     }
//   });

//   mo.observe(document.documentElement, {
//     subtree: true,
//     attributes: true,
//     attributeFilter: ['open']
//   });

//   // Optional: re-enforce after Shopify section loads in editor/live
//   document.addEventListener('shopify:section:load', (evt) => {
//     const root = evt.target || document;
//     root.querySelectorAll(SEL).forEach((acc) => {
//       if (acc.open) closeSiblingsOf(acc);
//     });
//   });
// })();

// hides the header as soon as footer element reaches 50% of the viewport
(() => {
    function initFooterHeaderBehavior() {
        const footer =
        document.querySelector('.shopify-section--footer') ||
        document.querySelector('footer');

        if (!footer || !('IntersectionObserver' in window)) return;

        if (window.footerHeaderObserver) {
        window.footerHeaderObserver.disconnect();
        }

        window.footerHeaderObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
            document.documentElement.classList.toggle(
                'footer-in-view',
                entry.isIntersecting
            );
            });
        },
        {
            rootMargin: '0px',
            threshold: 0.5
        }
        );

        window.footerHeaderObserver.observe(footer);
    }

    if (document.readyState === 'loading') {
        document.addEventListener(
        'DOMContentLoaded',
        initFooterHeaderBehavior,
        { once: true }
        );
    } else {
        initFooterHeaderBehavior();
    }
})();

// // footer logo parallax effect for revealing the logo
// (function () {
//   const box = document.querySelector('.footer-logo');
//   const img = box && box.querySelector('img');
//   if (!box || !img) return;

//   function layout() {
//     if (!img.naturalWidth) return;
//     // let the box take its natural width, then size everything from it
//     box.style.height = '';
//     const w = box.clientWidth;
//     const h = w * img.naturalHeight / img.naturalWidth;
//     box.style.height = h + 'px';

//     const rect = box.getBoundingClientRect();
//     const docBottom = document.documentElement.scrollHeight;
//     // distance from the logo's bottom edge to the very end of the page
//     const gap = docBottom - (rect.bottom + window.scrollY);

//     img.style.width = w + 'px';
//     img.style.height = h + 'px';
//     img.style.left = rect.left + 'px';
//     img.style.bottom = gap + 'px';
//   }

//   addEventListener('resize', layout);
//   addEventListener('load', layout);
//   if (img.complete) layout(); else img.addEventListener('load', layout);
// })();

// footer logo parallax effect for revealing + shrinking the logo
(function () {
  const box = document.querySelector('.footer-logo');
  const img = box && box.querySelector('img');
  if (!box || !img) return;

  // ---- Tweak this ----
  const SHRINK = 0.08;   // 0.05 = 5%, 0.10 = 10%
  // --------------------

  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (n, a, b) => Math.min(Math.max(n, a), b);
  let ticking = false;

  img.style.transformOrigin = '50% 100%';   // shrinks toward its bottom centre
  img.style.willChange = 'transform';

  function layout() {
    if (!img.naturalWidth) return;
    box.style.height = '';
    const w = box.clientWidth;
    const h = w * img.naturalHeight / img.naturalWidth;
    box.style.height = h + 'px';

    const rect = box.getBoundingClientRect();
    const docBottom = document.documentElement.scrollHeight;
    const gap = docBottom - (rect.bottom + window.scrollY);

    img.style.width = w + 'px';
    img.style.height = h + 'px';
    img.style.left = rect.left + 'px';
    img.style.bottom = gap + 'px';
    shrink();
  }

  function shrink() {
    if (reduce) return;
    const rect = box.getBoundingClientRect();
    const h = rect.height || 1;
    const p = clamp((window.innerHeight - rect.top) / h, 0, 1);  // 0 → 1 as it reveals
    img.style.transform = 'scale(' + (1 - SHRINK * p).toFixed(4) + ')';
    ticking = false;
  }

  function onScroll() {
    if (!ticking) { requestAnimationFrame(shrink); ticking = true; }
  }

  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', layout);
  addEventListener('load', layout);
  if (img.complete) layout(); else img.addEventListener('load', layout);
})();

// play muted loop video if any on hover of prod. card
(() => {
  const scope = '.shopify-section--featured-collection';
  const cardSelector = 'product-card';
  const selector = '.product-card__hover-video';
  const figureSelector = `${scope} .product-card__figure`;

  const touchDevice = window.matchMedia('(hover: none), (pointer: coarse)');

  function getCard(target) {
    const card = target.closest(cardSelector);
    return card && card.closest(scope) ? card : null;
  }

  function prepareVideo(video) {
    if (touchDevice.matches || video.dataset.prepared) return;

    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'auto';
    video.dataset.prepared = 'true';

    video.load();
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting || touchDevice.matches) return;

      const video = entry.target.querySelector(selector);

      if (video) prepareVideo(video);
    });
  }, { rootMargin: '300px' });

  function observeCards() {
    if (touchDevice.matches) return;

    document.querySelectorAll(figureSelector).forEach((figure) => {
      if (figure.dataset.videoObserved) return;

      figure.dataset.videoObserved = 'true';
      observer.observe(figure);
    });
  }

  observeCards();

  new MutationObserver(observeCards).observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('pointerover', (event) => {
    if (touchDevice.matches || event.pointerType === 'touch') return;

    const card = getCard(event.target);

    if (!card || card.contains(event.relatedTarget)) return;

    const video = card.querySelector(selector);

    if (!video) return;

    prepareVideo(video);
    video.play().catch(() => {});
  });

  document.addEventListener('pointerout', (event) => {
    if (touchDevice.matches || event.pointerType === 'touch') return;

    const card = getCard(event.target);

    if (!card || card.contains(event.relatedTarget)) return;

    const video = card.querySelector(selector);

    if (!video) return;

    video.pause();

    try {
      video.currentTime = 0;
    } catch (_) {}
  });

  touchDevice.addEventListener('change', (event) => {
    if (!event.matches) {
      observeCards();
      return;
    }

    document.querySelectorAll(selector).forEach((video) => video.pause());
  });
})();

// playing video on initial load also
(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const playInitialVideo = (carousel) => {
      const slide = carousel.selectedSlide;
      if (!slide) return;

      const type = slide.getAttribute("data-media-type");
      if (type !== "video" && type !== "external_video") return;

      const media = slide.firstElementChild; // the <video-media> element
      if (media && typeof media.play === "function") {
        media.play();
      }
    };

    const init = (carousel) => {
      if (!carousel.hasAttribute("autoplay") || carousel._initialAutoplayDone) return;
      carousel._initialAutoplayDone = true;

      Promise.all([
        customElements.whenDefined("media-carousel"),
        customElements.whenDefined("video-media")
      ]).then(() => {
        // wait a frame so the carousel has scrolled to its initial index
        requestAnimationFrame(() => requestAnimationFrame(() => playInitialVideo(carousel)));
      });
    };

    document.querySelectorAll("media-carousel[autoplay]").forEach(init);

    // Cover section re-renders in the theme editor and variant changes that re-render the gallery
    document.addEventListener("shopify:section:load", (event) => {
      event.target.querySelectorAll("media-carousel[autoplay]").forEach(init);
    });
  });
})();

// Keep the custom cursor visible for videos
(() => {
  const CURSOR_TYPES = ["image", "video", "external_video"];

  // Keep the custom cursor visible for videos (theme hides it for anything but images).
  // Listening on document runs after the theme's own listener on <product-gallery>, so this wins.
  document.addEventListener("carousel:change", (event) => {
    const gallery = event.target.closest("product-gallery");
    const cursor = gallery?.querySelector(".product-gallery__cursor");
    if (!cursor) return;

    const type = event.detail.slide.getAttribute("data-media-type");
    cursor.toggleAttribute("hidden", !CURSOR_TYPES.includes(type));
  });

  // Click left/right half of a video slide to go previous/next (theme only does this for images)
  document.addEventListener("click", (event) => {
    const carousel = event.target.closest("product-gallery media-carousel");
    if (!carousel) return;

    if (event.target.closest("button, a[href]") || !window.matchMedia("screen and (pointer: fine)").matches) return;

    const type = carousel.selectedSlide?.getAttribute("data-media-type");
    if (type !== "video" && type !== "external_video") return;

    const rect = carousel.getBoundingClientRect();
    (event.clientX - rect.left) > carousel.clientWidth / 2 ? carousel.next() : carousel.previous();
  });
})();

// changing buy-it-now button text on pdp buy_buttons blocks and sticky buy_now button
(() => {
  const NEW_TEXT = "BUY NOW";

  const rename = (root = document) => {
    root.querySelectorAll(".shopify-payment-button__button--unbranded").forEach((btn) => {
      if (btn.textContent.trim() !== NEW_TEXT) {
        btn.textContent = NEW_TEXT;
      }
    });
  };

  rename();
  new MutationObserver(() => rename()).observe(document.body, { childList: true, subtree: true });
})();